import theme from '../../../theme'
import { withOpacity } from '../../utils/functions.utils'

export const questionCardStyle = {
    backgroundColor: withOpacity(theme.colors.colorPrimary, 0.08),
    borderRadius: 8,
    marginHorizontal: 15,
    marginBottom: 12,
    paddingVertical: 16,
    paddingHorizontal: 12,
}

export const fieldCardStyle = {
    backgroundColor: 'white',
    marginTop: 12,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 12,
}
